import MappedField from "./MappedField";

export default MappedField;
